<template>
  <v-card>
    <v-system-bar dark color="grey darken-1" height="50">
      <v-btn
        outlined
        small
        fab
        dark
        class="transparent"
        @click.stop="$router.go(-1)"
      >
        <v-icon>mdi-arrow-left-circle</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      Rôles Hors Groupe
      <v-spacer></v-spacer>

      <v-btn
        outlined
        small
        fab
        dark
        class="transparent"
        @click.stop="$router.go(-1)"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-system-bar>
    <v-dialog v-model="dialogNewRole" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">Rôle Hors Groupe</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="formRole" v-model="valid" lazy-validation>
            <v-text-field
              v-model="ll_role_hors_groupe"
              label="Rôle"
              prepend-icon="label"
              :rules="nameRules"
              required
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn rounded class="primary" text @click="closeDialog"
            >Annuler</v-btn
          >
          <v-btn rounded class="primary" text @click="updateCreateRole"
            >Sauvegarder</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-card-text>
      <v-btn
        color="blue-grey"
        class="ma-2 white--text"
        rounded
        @click="dialogNewRole = !dialogNewRole"
      >
        <v-icon left dark> mdi-plus-circle-outline </v-icon>
        Nouveau rôle
      </v-btn>
      <v-list>
        <v-list-item
          v-for="(item, index) in RolesHorsGroupe"
          :key="index"
          class="project"
        >
          <v-list-item-content>
            <v-list-item-title
              v-html="item.ll_role_hors_groupe"
            ></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card-text>
  </v-card> </template
>>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      dialogNewRole: false,
      dialogLoading: false,
      ll_role_hors_groupe: "",
      id_role: null,
      valid: true,
      nameRules: [
        (v) => !!v || "requis",
        (v) => (v && v.length >= 2) || "Au moins deux caractères",
      ],
    };
  },
  created() {
    this.GetAllRolesHorsGroupe();
  },

  computed: {
    ...mapState({
      user: (state) => state.Auth.user,
      RolesHorsGroupe: (state) => state.RolesHorsGroupe.RolesHorsGroupe,
    }),
  },
  methods: {
    ...mapActions({
      GetAllRolesHorsGroupe: "RolesHorsGroupe/GetAll",
    }),
    openDialog(role) {
      this.dialogNewRole = true;
      this.ll_role_hors_groupe = role.ll_role_hors_groupe;
    },
    closeDialog() {
      this.ll_role_hors_groupe = "";
      this.dialogNewRole = false;
    },

    updateCreateRole() {
      let self = this;
      if (this.$refs.formRole.validate()) {
        //update role
        if (this.id_role !== null) {
          this.dialogLoading = true;
          let roleRef = this.$firebase
            .firestore()
            .collection("rolesHorsGroupe")
            .doc(this.id_role);
          return roleRef
            .update({
              ll_role_hors_groupe: self.ll_role_hors_groupe,
              modified: self.$firebase.firestore.FieldValue.serverTimestamp(),
            })
            .then(function () {
              // console.log("Bailleur successfully updated!");
              /*   self.udpdateProjetsDeBailleur(
                self.id_bailleur,
                self.abbr_bailleur,
                self.ll_bailleur
              );
              self.dialogLoading = false;
              self.id_bailleur = null; */

              self.closeDialog();
            })
            .catch(function (error) {
              // The document probably doesn't exist.
              console.error("Error updating document: ", error);
              self.closeDialog();
            });
        } else {
          let uuid = this.$uuid.v4();
          //create role
          this.dialogLoading = true;

          // Add a new document with a generated id.
          this.$firebase
            .firestore()
            .collection("rolesHorsGroupe")
            .doc(uuid)
            .set({
              ll_role_hors_groupe: self.ll_role_hors_groupe,
              created: self.$firebase.firestore.FieldValue.serverTimestamp(),
            })

            .then(function (docRef) {
              //console.log("New Document written with ID: ", docRef.id);             
              self.dialogLoading = false;
              self.id_role = null;
              self.GetAllRolesHorsGroupe();
              self.closeDialog();
            })
            .catch(function (error) {
              console.error("Error adding document: ", error);
              self.closeDialog();
            });
        }
      }
    },
  },
};
</script>

<style scoped></style>
